import { Component, signal, ChangeDetectionStrategy } from '@angular/core';

import {
  MdwCalendar,
  MdwDatePicker,
  MdwDateRangePicker,
} from '@spaces-ui/meadow/components/date-time';
import { DateRangeValue } from '@spaces-ui/meadow/components/date-time/models';

import { Sample } from '../../components';

@Component({
  selector: 'app-date-pickers',
  templateUrl: './date-pickers.html',
  styleUrls: ['./date-pickers.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Sample, MdwCalendar, MdwDatePicker, MdwDateRangePicker],
})
export class DatePickers {
  public value = signal<Date | undefined>(new Date());
  public calendarValue = signal<Date | null>(new Date());

  public rangeValue = signal<DateRangeValue | undefined>({
    startDate: this.get7DaysAgo(),
    endDate: new Date(),
  });

  private get7DaysAgo() {
    const date = new Date();
    date.setDate(date.getDate() - 7);
    return date;
  }
}
